<script>
export default {
  name: "CommentInput",
  props: {
    parentComment: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      value: ""
    }
  },
  emits: ["send", 'close-reply'],
  computed: {
    placeholder() {
      if(this.parentComment) {
        return `回复 ${this.parentComment.user.username}`;
      } else {
        return "发表评论";
      }
    }
  },
  methods: {
    onSend() {
      if(!this.value || !this.value.trim()) {
        this.$toast.fail("请输入评论内容");
        return;
      }
      this.$emit("send", this.value);
      this.value = "";
    },
    clear() {
      this.value = "";
    },
    focus() {
      this.$refs.myInput.focus();
    },
    onCloseReplay() {
      this.$emit('close-reply');
    }
  }
};
</script>

<template>
<div class="comment-input sticky bottom-0 bg-white p-3 border-t">
  <div v-if="parentComment" class="reply-message flex mb-2 items-center justify-between">
    <div class="flex items-center">
      <img :src="parentComment.user.head_url" alt="" class="w-6 h-6 rounded-full mr-2">
      <span class="text-xs text-gray-400">{{ parentComment.user.username }}</span>
    </div>
    <van-icon class="close" name="cross" @click="onCloseReplay"/>
  </div>
  <div class="flex bg-gray-200 rounded items-center pr-2">
    <van-field ref="myInput" v-model="value" :placeholder="placeholder" class="flex-1 mr-2 bg-transparent px-3" clearable type="text"/>
    <span @click="onSend">发送</span>
  </div>
</div>
</template>

<style scoped>
.icon {
  width: 1.5rem;
  height: 1.5rem;
}
</style>
